import React, { useEffect, useState } from "react"
import { toast } from "react-toastify"
import { useAuth } from "../../../contexts/AuthContext"
import { ENDPOINT } from "../../../constants"
import { FetchApi } from "../../../api/fetch"

const NewsletterBot = () => {
  const { getUserJWT } = useAuth()

  const [checking, setChecking] = useState(false)
  const [drafting, setDrafting] = useState(false)
  const [activating, setActivating] = useState(false)
  const [status, setStatus] = useState({ is_running: false })

  const activateBot = async () => {
    try {
      const userJWT = await getUserJWT()
      if (!userJWT) throw new Error("No token")
      setActivating(true)
      const data = await FetchApi({
        endpoint: ENDPOINT.ACTIVATE_NEWSLETTER_BOT,
        JWT: userJWT,
        headers: {
          "Cache-Control": "no-cache",
        },
      })

      toast.success(data.message)
    } catch (error) {
      toast.error((error as Error).message)
    } finally {
      setActivating(false)
    }
  }

  const draftPost = async () => {
    try {
      const userJWT = await getUserJWT()
      if (!userJWT) throw new Error("No token")
      setDrafting(true)
      const data = await FetchApi({
        endpoint: ENDPOINT.DRAFT_NEWSLETTER_POST,
        JWT: userJWT,
        headers: {
          "Cache-Control": "no-cache",
        },
      })
      if (!data.success) {
        throw new Error(data.message)
      }

      toast.success(data.message)
    } catch (error) {
      toast.error((error as Error).message)
    } finally {
      setDrafting(false)
    }
  }

  const checkBotStatus = async () => {
    try {
      const userJWT = await getUserJWT()
      if (!userJWT) throw new Error("No token")
      setChecking(true)
      const data = await FetchApi({
        endpoint: ENDPOINT.CHECK_NEWSLETTER_BOT_STATUS,
        JWT: userJWT,
        headers: {
          "Cache-Control": "no-cache",
        },
      })

      setStatus({ is_running: data.is_running })
    } catch (error) {
      toast.error((error as Error).message)
    } finally {
      setChecking(false)
    }
  }

  useEffect(() => {
    checkBotStatus()
  }, [])

  return (
    <div className="flex flex-col gap-5">
      <h1 className="font-medium text-2xl text-left">Newsletter</h1>
      <p>
        Status:{" "}
        {checking ? "..." : status.is_running ? "Running" : "Not running"}
      </p>
      <div className="flex gap-5">
        <button
          onClick={checkBotStatus}
          className="w-fit p-[1px] bg-gradient text-white font-medium rounded-xl"
        >
          <span className="bg-kyzzen-primary block px-8 py-2 rounded-xl">
            {checking ? "Checking..." : "Refresh status"}
          </span>
        </button>
        <button
          onClick={draftPost}
          className="w-fit p-[1px] bg-gradient text-white font-medium rounded-xl"
        >
          <span className="bg-kyzzen-primary block px-8 py-2 rounded-xl">
            {drafting ? "Drafting..." : "Draft post"}
          </span>
        </button>
        {!status.is_running && (
          <button
            onClick={activateBot}
            className="w-fit p-[1px] bg-gradient text-white font-medium rounded-xl"
          >
            <span className="bg-kyzzen-primary block px-8 py-2 rounded-xl">
              {activating ? "Activating..." : "Activate bot"}
            </span>
          </button>
        )}
      </div>
      <hr className="border border-gray-80 " />
    </div>
  )
}

export default NewsletterBot
